import useTableColumnsCuadre from "@/erp/inventario/cuadre-inventario/shared/hook/useTableColumnsCuadre";
import { 
  EstadoCuadreENUM, gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg9, 
  TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering 
} from "@/shared";
import { useFetchGetCuadreInventario } from "@/shared/actions/erp/inventario/cuadre.actions";
import { GeneralTable, SearchComponente } from "@/shared/components/ui";
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker";
import { ICuadreInventario } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { Grid } from "@mui/material";
import Flatpickr from 'react-flatpickr';
import { useRef, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useCuadreMaterial } from "@/erp/inventario/cuadre-inventario/shared/hook/useCuadreMaterial.store";
import SampleTableFullData from "@/shared/components/ui/SampleTableFullData";
//import { useCuadreEquipo } from "@/erp/inventario/cuadre-inventario/shared/hook/useCuadreEquipo.store";

export default function TableCuadreTecnico() {

  const flatpickrRef = useRef<Flatpickr>(null);
  const [modal, setModal] = useState(false);

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
    onChangeRangeDate,

  } = useTableFilter();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();


  const {
    pageIndex,
    pageSize
  } = pagination

  const {
    columnsCuadreTecnico,
    columnViewCuadreTecnico
  } = useTableColumnsCuadre();


  ///* 
  const handleCopiarLista = useCuadreMaterial(s => s.handleCopiarLista)
  const productos = useCuadreMaterial(s => s.productos)

  ///* fetch data
  const {
    data: cuadreRes,
    isLoading,
    isRefetching,
  } = useFetchGetCuadreInventario({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      nombre: searchTerm,
      estado_cuadre: EstadoCuadreENUM.FINALIZADO,
      numero_referencia: searchTerm,
      ...filterObject,
      filterByState: false,
    }
  });


  ///* handlers
  const onEdit = (cuadre: ICuadreInventario) => {
    setModal(true);
    handleCopiarLista(cuadre.materiales_utilizados ?? []);
  };

  const onClose = () => {
    setModal(false)
  }

  return (
    <>
      <Grid container spacing={3}>

        <Grid item {...gridSizeMdLg9}>
          <SearchComponente
            onChange={onChangeFilter}
            value={globalFilter}
            text="por número de cuadre" />
        </Grid>

        <DateRangePicker
          size={gridSizeMdLg3}
          flatpickrRef={flatpickrRef}
          onChange={range => onChangeRangeDate(range)}
        />

        <Grid item {...gridSizeMdLg12}>

          <GeneralTable<ICuadreInventario>
            columns={columnsCuadreTecnico}
            data={cuadreRes?.data?.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // filters - llega al back
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={cuadreRes?.data?.count}
            // // actions ========
            enableColumnActions={true}
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
            positionActionsColumn="first"
            // crud
            onEdit={onEdit}
            enableEditing={true}
            canEdit={true}
            canDelete={false}
          // onDelete={onDelete}
          />

        </Grid>
      </Grid>

      <ScrollableDialogProps
        open={modal}
        title="📋 Cuadre de inventario"
        confirmVariantBtn="contained"
        minWidth="80%"
        contentNode={
          <Grid container spacing={3}>

            <Grid item xs={12}>
              <SampleTableFullData<any>
                columns={columnViewCuadreTecnico}
                data={productos}
                rowNumber={false}
                isLoading={false}
                labelRenderTopToolbarCustomActions="Materiales"
              />
            </Grid>

            {/* <Grid item xs={12}>
              <SampleTableFullData<any>
                columns={columnViewCuadreTecnico}
                data={eqproductos}
                rowNumber={false}
                isLoading={false}
                labelRenderTopToolbarCustomActions="Equipos"
              />
            </Grid> */}
          </Grid>
        }
        onCloseIcon={onClose}
      />

    </>
  )

}